// Mock data for energy IoT gateways
export const mockIoTGateways = [
  {
    deviceId: "ENGGW001",
    location: "Building A, Server Room",
    status: "Healthy",
    connectedDevices: 24,
    uptimeHours: 2184,
    cpuUsage: 32,
    memoryUsage: 45,
    temperatureCelsius: 38.5,
    firmwareVersion: "v2.9.3",
    networkStatus: {
      connectivityType: "Ethernet",
      signalStrength: 95,
      dataTransferred: 1458.7,
      lastPingTime: 23
    },
    maintenanceStatus: {
      lastMaintenance: "2024-09-20",
      nextScheduled: "2026-01-20", 
      alerts: []
    }
  },
  {
    deviceId: "ENGGW002",
    location: "Building B, Utility Room",
    status: "Warning",
    connectedDevices: 18,
    uptimeHours: 1056,
    cpuUsage: 67,
    memoryUsage: 82,
    temperatureCelsius: 55.3,
    firmwareVersion: "v2.9.2",
    networkStatus: {
      connectivityType: "Cellular",
      signalStrength: 72,
      dataTransferred: 982.3,
      lastPingTime: 48
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-10",
      nextScheduled: "2026-02-10", 
      alerts: ["High temperature warning", "Memory usage high"]
    }
  },
  {
    deviceId: "ENGGW003",
    location: "Building C, Electrical Room",
    status: "Critical",
    connectedDevices: 5,
    uptimeHours: 38,
    cpuUsage: 95,
    memoryUsage: 94,
    temperatureCelsius: 68.7,
    firmwareVersion: "v2.8.5",
    networkStatus: {
      connectivityType: "WiFi",
      signalStrength: 34,
      dataTransferred: 148.2,
      lastPingTime: 235
    },
    maintenanceStatus: {
      lastMaintenance: "2024-07-15",
      nextScheduled: "2026-01-15", 
      alerts: ["Critical temperature", "Connectivity issues", "CPU overload", "Maintenance overdue"]
    }
  },
  {
    deviceId: "gw-3045",
    location: "Building F, Utility Room",
    status: "Warning",
    connectedDevices: 16,
    uptimeHours: 1345,
    cpuUsage: 58,
    memoryUsage: 75,
    temperatureCelsius: 52.8,
    firmwareVersion: "v2.9.1",
    networkStatus: {
      connectivityType: "Cellular",
      signalStrength: 68,
      dataTransferred: 876.4,
      lastPingTime: 45
    },
    maintenanceStatus: {
      lastMaintenance: "2024-07-25",
      nextScheduled: "2026-01-25", 
      alerts: ["Battery degradation detected"]
    }
  },
  {
    deviceId: "vr-2034",
    location: "Building G, Electrical Room",
    status: "Warning",
    connectedDevices: 8,
    uptimeHours: 970,
    cpuUsage: 62,
    memoryUsage: 70,
    temperatureCelsius: 50.2,
    firmwareVersion: "v2.8.9",
    networkStatus: {
      connectivityType: "WiFi",
      signalStrength: 72,
      dataTransferred: 562.8,
      lastPingTime: 38
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-12",
      nextScheduled: "2026-02-12", 
      alerts: ["Performance degradation"]
    }
  }
];
